import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import dayjs from 'dayjs';
import { SsrCookieService } from './ssr-cookie.service';
import { StorageKey } from '~core/models/shared.models';

@Injectable()
export class StorageService {
  protected _platformId = inject(PLATFORM_ID);
  protected _cookieService = inject(SsrCookieService);
  protected get _isPlatformBrowser(): boolean {
    return isPlatformBrowser(this._platformId);
  }

  protected get _isPlatformServer(): boolean {
    return isPlatformServer(this._platformId);
  }

  saveKey(
    key: StorageKey,
    value: string | null | undefined,
    storage: 'session' | 'local' | 'cookie' = 'session'
  ): void {
    if (!value) {
      this.deleteKey(key, storage);
      return;
    }

    if (this._isPlatformServer || storage === 'cookie') {
      this._cookieService.set(key, value, {
        //TODO: add ability to configure data
        expires: dayjs().add(6, 'month').toDate()
      });
      return;
    }

    if (this._isPlatformBrowser) {
      const storageFn = storage === 'local' ? localStorage : sessionStorage;
      storageFn.setItem(key, value);
    }
  }

  deleteKey(
    key: StorageKey,
    storage: 'session' | 'local' | 'cookie' = 'session'
  ): void {
    if (this._isPlatformServer || storage === 'cookie') {
      this._cookieService.delete(key);
      return;
    }

    if (this._isPlatformBrowser) {
      const storageFn = storage === 'local' ? localStorage : sessionStorage;
      storageFn.removeItem(key);
    }
  }

  getKey(
    key: StorageKey,
    storage?: 'session' | 'local' | 'cookie'
  ): string | null {
    if (this._isPlatformServer || storage === 'cookie') {
      return this._cookieService.get(key);
    }

    if (this._isPlatformBrowser) {
      return storage === 'local'
        ? localStorage.getItem(key)
        : sessionStorage.getItem(key);
    }

    return null;
  }
}
